import React from 'react'
import { Container, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'

interface IAccordionContainer {
  title: string
  children: React.ReactNode
}

export default function AccordionContainer(props: IAccordionContainer) {
  return (
    <Container component='section' sx={{ width: 960, maxWidth: '100%', pt: 2 }} data-cy='faq-container'>
      <Typography variant='h2' textAlign='left' mb={4}>
        <FormattedMessage id={props.title} />
      </Typography>
      <Stack gap={1.25}>{props.children}</Stack>
    </Container>
  )
}
